import { Controller } from "@hotwired/stimulus"
import { loadScript } from "@paypal/paypal-js"
import { patch } from '@rails/request.js'

// Connects to data-controller="paypal"
export default class extends Controller {
  static targets = [ "container", "paymentId" ]
  static values = { url: String, redirect: String }

  connect() {
    let paypal

    try {
      this.loadPaypal()
          .then(paypal => {
            this.paypal = paypal
            try {
              this.renderPaypal(paypal)
                  .catch(error => console.error("failed to render the PayPal Buttons", error))
                  .then(() => console.log("PayPal Buttons rendered successfully"))
            } catch (error) {
              console.error("failed to render the PayPal Buttons", error)
            }
          })
    } catch (error) {
      console.error("failed to load the PayPal JS SDK script", error)
    }

    if (this.paypal) {
      console.log(paypal)
      try {
        this.renderPaypal(paypal)
            .catch(error => console.error("failed to render the PayPal Buttons", error))
            .then(() => console.log("PayPal Buttons rendered successfully"))
      } catch (error) {
        console.error("failed to render the PayPal Buttons", error)
      }
    }
  }

  async loadPaypal() {
    // sandbox
    // return await loadScript({ clientId: "AXa2n61RLzx_qbXy8o-Qw14SQv77hOqrJtw5x2Yz6octeWePV5rExJWJ0rkgBgXOKqoLEHDdA6HSKIXy" })

    // production
    return await loadScript({ clientId: "AcUTYfOqWFd5ffTmUyaHvGGFPDtpALSzwpNGX4jVI8bkY6f6j6CjaJ3xKfY5nbWBoq1RBK2zq-BMYQBI" })
  }

  async renderPaypal(paypal) {
    await paypal.Buttons({
      fundingSource: paypal.FUNDING.CARD,
      createOrder: (data, actions) => fetch('/agents/paypal_unit')
          .then(response => response.json())
          .then(data => actions.order.create(data)),
      onApprove: (data, actions) => {
        // console.log(this.payTarget)
        return actions.order.capture().then(details => {
          // console.log('Transaction completed:', details.id);
          this.postId(details.id)
        });
      },
    }).render(this.containerTarget)
  }

  async postId(id) {
    const response = await patch(this.urlValue, {
      body: JSON.stringify({ agent: { profile_attributes: { payment_id: id } } })
    })
    if (response.ok) {
      location.href = this.redirectValue
      // const body = await response.json
      // this.paymentIdTarget.value = id
      // this.containerTarget.classList.add('hidden')
      // this.payTarget.submit()
    }
  }
}
